import React from 'react'
import { Icon, PageHeader, FlexContainer, Button } from '@reapit/elements'
import OutageMemo from './outageMemo'

type ResumeBlockProps = {
    resumeData?: any[]
    callInProgressData?: any[]
    setResumeId: React.Dispatch<React.SetStateAction<string>>
    setCancelId: React.Dispatch<React.SetStateAction<string>>
    outageMessage?: string
    outageSeverity?: number
}

const ResumeBlock: React.FC<ResumeBlockProps> = ({ resumeData,callInProgressData, setResumeId, setCancelId, outageMessage, outageSeverity }) => {
  return (
    <>
      <PageHeader
        avatar={{
          src: 'in-progress.png',
          type: 'image',
        }}
        hasMaxWidth
        pageTitle={{
          children: 'Unfinished Calls',
          hasBoldText: true,
        }}
        pageSubtitle={{
          children: 'Please complete the calls below to ensure data is saved in the CRM and reporting is accurate.',
        }}
      />
      {outageMessage ? <OutageMemo outageMessage={outageMessage} outageSeverity={outageSeverity} /> : null}
      <FlexContainer hasMaxWidth isFlexColumn>
          {callInProgressData?.map((item, index) => (
              <div className="resume-block el-tile" key={index}>
                  <div className="resume-details">
                      <div className="resume-data">
                          <a target='_parent' href={item.call_trigger_url || '#'}>{item.lead_category} - {item.lead_address}</a>
                      </div>
                      <div className="resume-date">{new Date(item.created_at).toLocaleDateString()}</div>

                      <div className="resume-number processing-call-note">Processing Call...</div>
                  </div>
              </div>
          ))}

        {resumeData?.map((item, index) => (
          <div className="resume-block el-tile" key={index}>
            <div className="resume-details">
              <div className="resume-data">
                <a target='_parent' href={item.call_trigger_url || '#'}>{item.lead_category} - {item.lead_address}</a>
              </div>
              <div className="resume-date">{new Date(item.created_at).toLocaleDateString()}</div>
              <div className="resume-type">
                <p
                  data-testid="display"
                  style={{
                    textTransform: 'capitalize',
                    fontSize: '0.75rem',
                    display: 'flex',
                    alignItems: 'center',
                    color: item.call_direction == 'inbound' ? '#38A169' : '#6B46C1',
                  }}
                >
                  {item.call_direction === 'inbound' ? <Icon icon="arrowLeft" /> : <Icon icon="arrowRight" />}
                  {item.call_direction ?? 'outbound'}
                </p>
              </div>
              <div className="resume-number">{item.destination}</div>
            </div>
            <div className="resume-info">
              <div className="resume-summary">{item.summary}</div>
              <div>
                <FlexContainer isFlexAlignCenter isFlexJustifyEnd style={{ gap: '10px' }}>
                  <Button onClick={() => setResumeId(item.id)}>Resume</Button>
                  <Icon className="pointer" icon="trash" onClick={() => setCancelId(item.id)} />
                </FlexContainer>
              </div>
            </div>
          </div>
        ))}
      </FlexContainer>
    </>
  )
}

export default ResumeBlock
